import { Injectable } from '@angular/core';
import { DefaultEnvVariables } from './environment.default';
import * as debug from 'debug';

@Injectable()
export class EnvVariables extends DefaultEnvVariables {
  log = debug('app:EnvVariables.template');

  environment = 'dev';
  production = false;
  forceAnalaytics = 'true';
  apiURL = 'https://cdllife-mobile-api.herokuapp.com';
  apiURLv2 = 'https://cdllife-social-api-de8837e87b0c.herokuapp.com';
  adNetworkURL = 'https://cdllife-mobile-api.herokuapp.com';
  eventAPIURL = 'https://cdllife-mobile-api.herokuapp.com';
  recaptchaURL = 'https://dedicatedjobs.cdllife.com/recaptcha';
  user = null;
  openWeatherApiKey = '3abbb8358b57cb42b73f83417e96b36d';
  highwayHuntUrl = 'https://highwayhunt.cdllife.com';
  dedicatedJobsUrl = 'https://dedicatedjobs.cdllife.com';
  branchKey = 'web:matt/mobile-desktop';
  simpleEncryptionUUID = 'fb564b37-5296-4a06-bf92-c31f8e5dc734';

  constructor() {
    super();
    setTimeout(() => {
      this.log('ENV', this.environment, this);
    });
  }
}



// WEBPACK FOOTER //
// ./src/environments/environment.template-replaced.ts